/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import {
  Checkbox,
  Dropdown,
  Empty,
  MenuProps,
  notification,
  Select,
  Spin,
  Tooltip,
  Typography,
} from "antd";
import { Menu } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  deleteSearch,
  filterSearchResult,
  getMainSearchResult,
  getSearchStats,
  saveSearchMark,
} from "api/search.api";
import { getProjects } from "api/project.api";
import BottomCandidateSelect from "components/TalentPools/Candidates/BottomCandidateSelect";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { useAppSelector } from "hooks/reduxHooks";
import { useFilterCriteria } from "utils/GetFilterCriteria";
import { useSearchParams } from "react-router-dom";
import {
  resetFilterCriteria,
  setAllFilterCriteria,
  setIsLoadingCandidates,
  setKeywordsData,
} from "store/slices/filtercriteria.slice";
import { gql, useLazyQuery } from "@apollo/client";
import { readToken } from "services/localStorage.service";
import { changeIsNamedSearch, resetSearch } from "store/slices/searcSlice";
import _ from "lodash";
import { MediumTitle } from "components/Common/Typography/Titles";
import StickyBox from "react-sticky-box";
import SearchCandidatesHeader from "components/SearchResult/SearchCandidatesHeader";
import SearchResultCandidateList from "components/SearchResult/Search Results/SearhResultCandidateList";
import SearchResultList from "./SearchResultList";

interface SearchResultProps {
  searchId: number;
}

interface SearchResultStat {
  total_pages: number;
  total_candidates: number;
  search_status: boolean;
}

export const COUNT_SEARCH = gql`
  query Count($configId: Int, $token: String!) {
    countSearch(configId: $configId, token: $token) {
      total
      details {
        name
        count
      }
    }
  }
`;

const AllSearchedCandidates: React.FC<SearchResultProps> = ({ searchId }) => {
  const pageCount = 10;
  const [allIdsSelected, setAllIdsSelected] = useState<boolean>(false);
  const [searchResultStat, setSearchResultStat] = useState<SearchResultStat>({
    total_pages: 0,
    total_candidates: 0,
    search_status: false,
  });

  const [searchResult, setSearchResult] = useState<any | null>(null);
  const rejectedCandidate = useSelector((state: any) => state.refresh.rejectedCandidate);
  const [candidateList, setCandidateList] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [isSearchSave, setIsSearchSave] = useState<boolean>(false);
  const [loadMoreDataFunctionCall, setLoadMoreDataFunctionCall] = useState<boolean>(false);
  const [projectPage, setProjectPage] = useState<number>(1);
  const [projects, setProjects] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pollStart, setPollStart] = useState<boolean>(false);
  const [candidateLoading, setCandidateLoading] = useState<boolean>(true);
  const [selectedCandidates, setSelectedCandidates] = useState<number[]>([]);
  const defaultSelectedProject = useAppSelector((state: RootState) => state.search.selectedProject);
  const [isFilterChange, setFilterChange] = useState(false);
  const [isFilter, setFilter] = useState(false);
  const searchRefresh = useSelector((state: any) => state.refresh.searchResultRefresh);
  const [expandableKeys, setExpandableKeys] = useState<any>(["1"]);
  const selectedPool = useSelector((state: RootState) => state.search.selectedProject);
  const [getCandidateCount, { data: countData }] = useLazyQuery(COUNT_SEARCH);
  console.log(candidateList, "candidateListcandidateListcandidateList");
  const [jobTitlesData, setJobTitlesData] = useState<any>([]);
  const [locationsData, setLocationsData] = useState<any>([]);
  const [excludeLocationsData, setExcludeLocationsData] = useState<any>([]);
  const [minExp, setMinExp] = useState<any>(0);
  const [maxExp, setMaxExp] = useState<any>(60);
  const [startYear, setStartYear] = useState<any>(1960);
  const [endYear, setEndYear] = useState<any>(2030);
  const [skillsData, setSkillsData] = useState<any>([]);
  const [universitiesData, setUniversitiesData] = useState<any>([]);
  const [industryData, setIndustryData] = useState<any>([]);
  const [companyData, setCompanyData] = useState<any>([]);
  const [industryLeaderData, setIndustryLeaderData] = useState<any>([]);
  const [excludeData, setExcludeData] = useState<any>([]);
  const [searchKeywords, setSearchKeywords] = useState<any>([]);

  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const filterId = searchParams.get("filterId");

  const [jobId, setJobId] = useState<any>(null);
  const [searchTitle, setSearchTitle] = useState<any>(null);
  const [pipeLineId, setPipelineId] = useState<any>(null);

  const setFilterCriteria = (criteria: any) => {
    const data = criteria.reduce((acc: any, current: any) => {
      switch (current.field_to_filter) {
        case "total_experience":
          acc.minExp = current.min_exp;
          acc.maxExp = current.max_exp;
          break;
        case "year_of_graduation":
          acc.startYear = current.start_year;
          acc.endYear = current.end_year;
          break;
        case "education_experience":
          acc.universitiesData = current.filter_value; // Map to universitiesData
          break;
        case "industry":
          acc.industryData = current.filter_value; // Map to industryData
          break;
        case "all_companies":
          acc.allCompanies = current.filter_value; // Map to industryLeaderData
          break;
        case "titles":
          acc.jobTitlesData = current.filter_value; // Map to jobTitlesData
          break;
        case "location":
          acc.locationsData = current.filter_value; // Map to locationsData
          break;
        case "locations_exclude":
          acc.excludeLocationsData = current.filter_value; // Map to excludeLocationsData
          break;
        case "keyword":
          acc.keywordsData = current.filter_value; // Map to keywordsData
          break;
        case "skills":
          acc.skillsData = current.filter_value; // Map to skillsData
          break;
        default:
          // Handle any unrecognized fields
          acc[current.field_to_filter] = current.filter_value;
          break;
      }
      return acc;
    }, {});

    dispatch(setAllFilterCriteria(data));
  };

  const changeCompanyDataToObj = (data: any) => {
    const newData: any = [];
    if (data && data.length) {
      for (let index = 0; index < data.length; index++) {
        if (typeof data[index] === "string") {
          newData.push({ name: data[index], year_from: "", year_to: "" });
        } else {
          newData.push(data[index]);
        }
      }
    }
    return newData;
  };

  function getValueByFieldToFilter(field: string, data: any) {
    const index = data.findIndex((d: any) => d.field_to_filter === field);
    if (index !== -1) {
      if (field !== "total_experience" && field !== "year_of_graduation") {
        return data[index].filter_value;
      } else if (field === "year_of_graduation") {
        return {
          start_year: data[index].start_year,
          end_year: data[index].end_year,
        };
      } else {
        return { min_exp: data[index].min_exp, max_exp: data[index].max_exp };
      }
    }
  }

  const getSearchResult = (id: number | any, filterData: any = null) => {
    const pageNumber = 1;
    const shouldFetchMoreResults =
      searchResultStat &&
      searchResult &&
      searchResultStat.total_candidates > searchResult?.count &&
      searchResult?.count < 10;

    if (!shouldFetchMoreResults) {
      setCandidateList([]);
      setCandidateLoading(true);
      setSearchResult(null);
    }
    setIsLoading(true);
    setSelectedCandidates([]);
    setPage(pageNumber + 1);
    getMainSearchResult(id, {}, pageNumber, filterData ? filterData : {}, filterId)
      .then((data: any) => {
        if (data && data.job && data.job.id) {
          setJobId(data.job.id);
        }
        if (data && data.pipeline && data.pipeline.id) {
          setPipelineId(data.pipeline.id);
        }
        setSearchTitle(data.search_title);
        setIsLoading(false);
        setSearchResult(data);
        setIsSearchSave(data.is_saved);
        setCandidateList(data.results);
        setPage(pageNumber + 1);
        // if (data.total_pages) {
        //   setSearchResultStat((prev) => ({
        //     ...prev,
        //     total_pages: data.total_pages,
        //     total_candidates: data.total_candidates,
        //   }));
        // }

        if (data.filters_criteria && data.filters_criteria.length) {
          const sideFilterKeys = [...expandableKeys];
          const titleData = getValueByFieldToFilter("titles", data.filters_criteria);
          if (titleData && titleData.length) {
            sideFilterKeys.push("1");
          }
          const skillsData = getValueByFieldToFilter("skills", data.filters_criteria);
          if (skillsData && skillsData.length) {
            sideFilterKeys.push("5");
          }
          const keywordsData = getValueByFieldToFilter("keyword", data.filters_criteria);
          if (keywordsData && keywordsData.length) {
            sideFilterKeys.push("2");
          }
          const locationsData = getValueByFieldToFilter("location", data.filters_criteria);

          const excludeLocationsData = getValueByFieldToFilter(
            "locations_exclude",
            data.filters_criteria
          );
          const industryData = getValueByFieldToFilter("industry", data.filters_criteria);
          if (industryData && industryData.length) {
            sideFilterKeys.push("6");
          }
          const industryLeaderData = changeCompanyDataToObj(
            getValueByFieldToFilter("all_companies", data.filters_criteria)
          );
          if (industryLeaderData && industryLeaderData.length) {
            sideFilterKeys.push("7");
          }

          const universitiesData = getValueByFieldToFilter(
            "education_experience",
            data.filters_criteria
          );
          if (universitiesData && universitiesData.length) {
            sideFilterKeys.push("9");
          }
          const min_Exp = getValueByFieldToFilter(
            "total_experience",
            data.filters_criteria
          ).min_exp;

          const max_exp = getValueByFieldToFilter(
            "total_experience",
            data.filters_criteria
          ).max_exp;
          if (min_Exp !== 0 || max_exp !== 60) {
            sideFilterKeys.push("3");
          }
          setExpandableKeys(sideFilterKeys);

          setJobTitlesData(titleData ? titleData : []);
          setSkillsData(skillsData && skillsData.length ? skillsData : []);

          setKeywordsData(keywordsData && keywordsData.length ? keywordsData : []);

          setIndustryData(industryData && industryData.length ? industryData : []);

          setIndustryLeaderData(
            changeCompanyDataToObj(
              industryLeaderData && industryLeaderData.length ? industryLeaderData : []
            )
          );
          dispatch(resetSearch());
          setCompanyData(changeCompanyDataToObj(data && data.company ? data.company : []));

          setUniversitiesData(universitiesData && universitiesData.length ? universitiesData : []);
          setMinExp(min_Exp ? min_Exp : minExp);
          setMaxExp(max_exp ? max_exp : maxExp);
        }
      })
      .finally(() => {
        dispatch(setIsLoadingCandidates(false));
        setCandidateLoading(false);
      });
  };

  const filterSearch = (updateSearch = false) => {
    setIsLoading(true);
    const pageNumber = 1;
    const shouldFetchMoreResults =
      searchResultStat &&
      searchResult &&
      searchResultStat.total_candidates > searchResult?.count &&
      searchResult?.count < 10;
    if (!shouldFetchMoreResults) {
      setCandidateList([]);
      setCandidateLoading(true);
      setSearchResult(null);
    }
    setIsLoading(true);

    setFilterChange(true);
    setPage(pageNumber);
    const controller = new AbortController();
    const win: any = window;
    if (win["axiosAbort"]) win["axiosAbort"].abort();
    win["axiosAbort"] = controller;
    filterSearchResult(
      {
        search_id: searchId,
        job: jobId,
        pipeline: pipeLineId,
        search_text: searchTitle,
        update_search: updateSearch,
        locations: locationsData,
        locations_exclude: excludeLocationsData,
        company: changeCompanyDataToObj(companyData),
        companies_exclude: excludeData,
        job_title: jobTitlesData,
        industries: industryData,
        universities: universitiesData ? universitiesData.toString() : "",
        skills: skillsData,
        minExp: minExp,
        maxExp: maxExp,
        // search_wizard_config: {
        //   locations: locationsData,
        //   company: changeCompanyDataToObj(industryLeaderData),
        //   companies_exclude: excludeData,
        //   job_title: jobTitlesData,
        //   industries: industryData,
        //   universities: universitiesData ? universitiesData.toString() : "",
        //   skills: skillsData,
        //   minExp: minExp,
        //   maxExp: maxExp,
        //   keyword: keywordsData,
        //   locations_exclude: excludeLocationsData,
        // },
        page: pageNumber,
        filters_criteria: filters_criteria,
      },
      { signal: controller.signal }
    )
      .then((data: any) => {
        const win: any = window;
        win["axiosAbort"] = "";
        setSearchKeywords(filters_criteria);
        // const filterCrit = filters_criteria;
        setSearchTitle(data.search_title);
        setSearchResult(data);
        setIsSearchSave(data.is_saved);

        setCandidateList(data.results);
        setPage(pageNumber + 1);
        if (data.is_name_search) {
          dispatch(changeIsNamedSearch(data.is_name_search));
        }
        // getSearchResult(searchId, {
        //   filters_criteria: filterCrit,
        // });
      })
      .catch(() => {
        console.log("Failed");
      })
      .finally(() => {
        dispatch(setIsLoadingCandidates(false));
        setCandidateLoading(false);
      });
  };

  const poll = ({ interval, maxAttempts }: { interval: number; maxAttempts: number }) => {
    let attempts = 0;
    let alreadyRefreshed = false;
    let isTerminated = false; // Flag to terminate polling
    setPollStart(true);
    const executePoll = async (resolve: any, reject: any) => {
      if (isTerminated) {
        setPollStart(false);
        return reject(new Error("Polling operation terminated"));
      }

      if (interval && interval % 10 === 0) {
        getCandidateCount({
          variables: {
            configId: searchId,
            token: readToken(),
          },
        });
      }
      const result: any = await getSearchStats(searchId, filters_criteria);
      attempts += 1;

      setSearchResultStat((prev) => ({
        ...prev,
        search_status: result.search_status,
        total_pages: result.total_pages,
        total_candidates: result.total_candidates,
      }));

      if (
        (!candidateList?.length && result.total_candidates && !alreadyRefreshed) ||
        (candidateList?.length && candidateList?.length < pageCount * page)
      ) {
        alreadyRefreshed = true;
        setLoadMoreDataFunctionCall(true);
      }
      if (
        (maxAttempts && attempts === maxAttempts) ||
        result.search_status === false ||
        (window.location.pathname &&
          window.location.pathname.indexOf("search/search-result/") === -1)
      ) {
        setPollStart(false);
        return resolve(result);
      } else {
        setTimeout(executePoll, interval, resolve, reject);
      }
    };

    const terminatePoll = () => {
      isTerminated = true;
    };

    return {
      start: new Promise(executePoll),
      terminate: terminatePoll,
    };
  };

  useEffect(() => {
    let currentPoll: { start: Promise<any>; terminate: () => void } | null = null;
    if (searchResult && searchResult.search_status) {
      currentPoll = poll({ interval: 3000, maxAttempts: 70 });

      currentPoll.start
        .then((data: any) => {
          setSearchResultStat((prev) => ({
            ...prev,
            total_pages: data.total_pages,
            total_candidates: data.total_candidates,
          }));
        })
        .catch((error: any) => {
          console.error("Polling error:", error.message);
        });
    } else {
      setSearchResultStat((prev) => ({
        ...prev,
        total_candidates: searchResult?.count,
        total_pages: searchResult?.total_pages,
      }));
    }

    // Cleanup function to terminate the previous poll
    return () => {
      if (currentPoll) {
        currentPoll.terminate();
        currentPoll = null;
      }
    };
  }, [searchId, searchResult, searchRefresh]);

  const [selectedValueproject, setSelectedValueproject] = useState(null);

  const handleChangeproject = (value: any) => {
    setSelectedValueproject(value);
  };

  const [selectedValueallProfiles, setSelectedValueallProfiles] = useState(null);

  const handleChangeallProfiles = (value: any) => {
    setSelectedValueallProfiles(value);
  };

  const [selectedValuehightolow, setSelectedValuehightolow] = useState(null);

  const handleChangehightolow = (value: any) => {
    setSelectedValuehightolow(value);
  };

  const filters_criteria = useFilterCriteria();

  const handleSaveSearch = async () => {
    try {
      const saveSearchResponse = await saveSearchMark(searchId, true, filters_criteria);

      notification.success({
        message: "Success",
        description: "Successfully saved search",
      });
      setIsSearchSave(true);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Error in saving search",
      });
      console.error("Error fetching search result:", error);
    }
  };
  const handleDeleteSearch = async () => {
    try {
      const saveSearchResponse = await deleteSearch(searchId);
      setIsSearchSave(false);
    } catch (error) {
      console.error("Error fetching search result:", error);
    }
  };

  const getProjectList = async () => {
    setIsLoading(true);
    try {
      const data = await getProjects(projectPage);
      if (data) {
        setProjects(data?.results);
      }
      // setProjects((prevProjects) => {
      //   const existingIds = new Set(prevProjects.map((project) => project.id));
      //   const newProjects = data.results.filter((project) => !existingIds.has(project.id));
      //   return [...prevProjects, ...newProjects];
      // });
      // setProjectsHasMore(data.next !== null);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectCandidate = (candidateId: number) => {
    if (selectedCandidates.includes(candidateId)) {
      setSelectedCandidates(selectedCandidates.filter((id) => id !== candidateId)); // Remove if already selected
    } else {
      setSelectedCandidates([...selectedCandidates, candidateId]); // Add if not selected
    }
  };

  const allCandidatesSelected: boolean = candidateList
    ?.map((candidate: any) => candidate.id)
    .every((id: number) => selectedCandidates.includes(id));

  const handleSelectAllCandidates = () => {
    const allIds = candidateList?.map((candidate: any) => candidate.id);

    if (allCandidatesSelected) {
      setSelectedCandidates([]);
      setAllIdsSelected(false);
    } else {
      setSelectedCandidates(allIds);
    }
  };

  const loadMoreData = () => {
    // if (totalPages <= currentPage && !forceLoad) {
    //     return;
    //   }

    getMainSearchResult(searchId, {}, page, {
      filters_criteria: filters_criteria,
    }).then((body: any) => {
      const profData = [...candidateList, ...body.results];
      const unique = _.uniqBy(profData, "id");
      setCandidateList([...unique]);
      setCandidateList([...unique]);
      setPage(page + 1);
    });
  };

  const unselectAllCandidates = () => {
    setSelectedCandidates([]);
    setAllIdsSelected(false);
  };

  useEffect(() => {
    setFilter(true);
    filterSearch(isFilter);
    setPage(1);
  }, [searchRefresh]);

  useEffect(() => {
    if (searchResult && searchResult.filters_criteria) {
      if (searchResult.filters_criteria.length > 0) {
        setFilterCriteria(searchResult?.filters_criteria);
      } else {
        dispatch(resetFilterCriteria());
      }
    }
  }, [searchResult]);

  useEffect(() => {
    const shouldFetchMoreResults =
      searchResultStat &&
      searchResult &&
      searchResultStat.total_candidates > searchResult?.count &&
      searchResult?.count < 10;

    if (shouldFetchMoreResults) {
      const fetchResults = isFilterChange
        ? () => filterSearch(false)
        : () => getSearchResult(searchId);
      fetchResults();
    }
  }, [searchResultStat.total_candidates]);

  useEffect(() => {
    const fetchResults = isFilterChange
      ? () => filterSearch(false)
      : () => getSearchResult(searchId);
    fetchResults();
  }, []);

  // useEffect(() => {
  //   if (rejectedCandidate) {
  //     setCandidateList((prevCandidates: any) =>
  //       prevCandidates.filter((candidate: any) => !rejectedCandidate.includes(candidate.id))
  //     );
  //   }
  // }, [rejectedCandidate]);

  const menu = (
    <Menu>
      <Menu.Item key="1">Job Title 1</Menu.Item>
      <Menu.Item key="2">Job Title 2</Menu.Item>
    </Menu>
  );

  const handleSetSelectAllCandidates = (value: any) => {
    setAllIdsSelected(value.target.checked);
    handleSelectAllCandidates();
  };

  const handleShortlistCandidate = useCallback((candidateId: number) => {
    setCandidateList((prev: any) => prev.map((candidate: any) =>
      candidate.id === candidateId
        ? {
          ...candidate,
          is_shortlisted: true,
          is_rejected: false // Ensure not rejected if shortlisted
        }
        : candidate
    ));
  }, []);

  // Function to reject a candidate
  const handleRejectCandidate = (candidateId: number) => {
    setCandidateList((prev: any) => prev.map((candidate: any) =>
      candidate.id === candidateId
        ? {
          ...candidate,
          is_rejected: true,
          is_shortlisted: false // Ensure not shortlisted if rejected
        }
        : candidate
    ));
  };

  useEffect(() => {
    if (allIdsSelected) {
      handleSelectAllCandidates();
    }
  }, [candidateList]);

  const headerRef = useRef<HTMLDivElement | null>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    updateHeight(); // Initial height
    window.addEventListener("resize", updateHeight); // Update on resize

    return () => window.removeEventListener("resize", updateHeight); // Cleanup
  }, [searchResultStat]);

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Checkbox
          checked={allCandidatesSelected} // Set the checkbox state based on if all candidates are selected
          onChange={handleSelectAllCandidates}
        >
          <MediumTitle
            text={`${allIdsSelected
              ? `${searchResult?.count} Selected`
              : allCandidatesSelected
                ? `${selectedCandidates.length} Selected`
                : `${candidateList?.length || 0} Select`
              }`}
            color="text-text-secondary font-normal"
          />
        </Checkbox>
      ),
    },
    {
      key: "2",
      label: (
        <Checkbox
          checked={allIdsSelected} // Set the checkbox state based on if all candidates are selected
          onChange={handleSetSelectAllCandidates}
        >
          <MediumTitle text={"Select all"} color="text-text-secondary font-normal" />
        </Checkbox>
      ),
    },
  ];
  return (
    <div className="flex">
      <div
        className="bg-utility-Grayblue w-reduce-sidebar ml-auto h-calc-vh overflow-y-auto overflow-x-hidden custom-scrollbar"
        id="scrollableDiv"
      >
        <div>
          <div ref={headerRef} className="sticky top-0 z-[1]">
            <SearchCandidatesHeader
              searchResult={searchResult}
              jobId={searchResult?.job?.id}
              searchResultStat={searchResultStat}
              isSearchSave={isSearchSave}
              handleDeleteSearch={handleDeleteSearch}
              handleSaveSearch={handleSaveSearch}
              pollStart={pollStart}
              candidateLoading={candidateLoading}
              refreshResult={() => {
                if (isFilterChange) {
                  filterSearch(false);
                } else {
                  getSearchResult(searchId);
                }
                //
              }}
            />

          </div>

          <div className="mx-6 my-4">
            {/* <PastCandidates /> */}

            <div className="px-4 bg-white py-6 mt-6">
              <StickyBox offsetTop={headerHeight} className={`z-[1]`}>
                <div className="flex gap-12  flex-1 pb-2 pt-1 border-b border-dashed border-main-border bg-white">
                  <div className="w-1/4">
                    <div className="flex items-center gap-2">
                      <Checkbox
                        disabled={pollStart || searchResultStat.search_status}
                        checked={allIdsSelected} // Set the checkbox state based on if all candidates are selected
                        onChange={handleSetSelectAllCandidates}
                      >
                        <MediumTitle text={"Select All"} color="text-text-secondary font-normal" />
                      </Checkbox>
                    </div>
                  </div>
                </div>
              </StickyBox>
              <Spin size="large" spinning={candidateLoading}>
                {candidateList?.length === 0 && !candidateLoading ? (
                  <div className="p-10">
                    <Empty description={<Typography.Text>No Search Found!</Typography.Text>} />
                  </div>
                ) : (
                  <>
                    <SearchResultList
                      searchResult={searchResult}
                      handleSelectCandidate={handleSelectCandidate}
                      selectedCandidates={selectedCandidates}
                      selectedPool={searchResult?.job?.id ?? defaultSelectedProject?.id}
                      searchId={searchId}
                      page={page}
                      loadMoreData={loadMoreData}
                      candidateList={candidateList}
                      setPage={setPage}
                      setCandidateList={setCandidateList}
                      loadMoreDataFunctionCall={loadMoreDataFunctionCall}
                      searchResultStat={searchResultStat}
                      candidateLoading={candidateLoading}
                      handleShortlistCandidate={handleShortlistCandidate}
                      handleRejectCandidate={handleRejectCandidate}
                    />
                  </>
                )}
              </Spin>
            </div>
          </div>
        </div>
        <BottomCandidateSelect
          selectedCandidates={selectedCandidates}
          selectedPool={selectedPool?.id || null}
          type="suggest"
          isSearch={true}
          allCandidates={candidateList?.length}
          unselectAllCandidates={unselectAllCandidates}
          // allCandidatesDetail={candidateList}
          searchId={searchId}
          allIdsSelected={allIdsSelected}
          totalCandidates={searchResult?.count ?? 0}
        />
      </div>
    </div>
  );
};

export default AllSearchedCandidates;
